import "./LeadingTitle.scss";

const LeadingTitle = (props) => {
  return (
    <div className="leading-title">
      <h1>{props.title}</h1>
      <div
            dangerouslySetInnerHTML={{
              __html: props.subtitle,
            }}
          ></div>
    </div>
  );
};

export default LeadingTitle;
